import { parseQuestionOptionsCsv } from '@/features/questionnaires/utils/parseQuestionOptionsCsv';
import { useNotification } from '@refinedev/core';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import type { QuestionOption } from '@aphp-ema/common/questionnaire';

export const useParseQuestionOptionsCsv = () => {
  const { t } = useTranslation();
  const { open: openNotification } = useNotification();

  const { mutateAsync: parseOptionsCsv, status } = useMutation({
    mutationFn: async (file: File): Promise<QuestionOption[]> => {
      const result = await parseQuestionOptionsCsv(file);
      return result.options;
    },
    onSuccess: (options) => {
      openNotification?.({
        type: 'success',
        message: t('pages.studies.questions.options.csvUploadSuccess', {
          count: options.length,
        }),
      });
    },
    onError: (error) => {
      let errorMessage = t(
        'pages.studies.questions.options.errors.unexpectedError',
      );

      if (error instanceof Error) {
        if (error.message === 'ENCODING_DETECTION_FAILED') {
          errorMessage = t(
            'pages.studies.questions.options.errors.encodingFailed',
          );
        } else if (error.message === 'INVALID_CSV_DATA') {
          errorMessage = t(
            'pages.studies.questions.options.errors.invalidCsvData',
          );
        }
      } else if (error === 'INVALID_CSV_DATA') {
        errorMessage = t(
          'pages.studies.questions.options.errors.invalidCsvData',
        );
      }

      openNotification?.({
        type: 'error',
        message: errorMessage,
      });
    },
  });

  const isLoading = status === 'loading';

  return { parseOptionsCsv, isLoading };
};
